import { render, staticRenderFns } from "./produceInfo.vue?vue&type=template&id=3f0e112c&scoped=true"
import script from "./produceInfo.vue?vue&type=script&lang=js"
export * from "./produceInfo.vue?vue&type=script&lang=js"
import style0 from "./produceInfo.vue?vue&type=style&index=0&id=3f0e112c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e112c",
  null
  
)

export default component.exports